/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { Component, PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './serviceConseil.css';
import Helmet from 'react-helmet';
import fetch from '../../core/fetch';
import { Link } from 'react-router';

const title = 'Service conseil';

@withStyles(s)
export default class ServiceConseil extends Component {
    
	constructor(props) {
        super(props);

        this.state = {
            serviceConseil: [],
            loader: true,
        };

        
    }

    componentDidMount(){

        this.GetServiceConseil();

    }

    async GetServiceConseil(){
        const resp = await fetch('/graphql', {
            method: 'post',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: '{serviceConseil{id, slug, title, content, titreBanniere, schemaLeft, schemaRight, sectionPourquoi, sectionServices}}',
            }),
            credentials: 'include',
        });
        const { data } = await resp.json();
        if (!data || !data.serviceConseil) throw new Error('Erreur sur le chargement de la page service conseil !');

        if(data){
            this.setState({ loader: false })
        }
        
        this.setState({ serviceConseil: data.serviceConseil })
    }

    render(){

        const topLink = <div className={`topLink`}>
                           <div className={`container`}>
                              <div className={`autreServices`}>
                                 <span>Nos autres services:</span>
                                 <ul>
                                    <li><Link to="/strategie-web">Stratégie web</Link></li>
                                    <li><Link to="/developpement-web">Développement Web</Link></li>
                                 </ul>
                              </div>
                           </div>
                        </div>;

        const titreBanniere = <div dangerouslySetInnerHTML={{ __html: this.state.serviceConseil.titreBanniere }} />;
        const topContent = <div dangerouslySetInnerHTML={{ __html: this.state.serviceConseil.content }} />;
        const schemaLeft = <div dangerouslySetInnerHTML={{ __html: this.state.serviceConseil.schemaLeft }} />;
        const schemaRight = <div dangerouslySetInnerHTML={{ __html: this.state.serviceConseil.schemaRight }} />;
        const sectionPourquoi = <div dangerouslySetInnerHTML={{ __html: this.state.serviceConseil.sectionPourquoi }} />;
        const sectionServices = <div dangerouslySetInnerHTML={{ __html: this.state.serviceConseil.sectionServices }} />;
        
        const appear = this.state.loader ? 'appear' : '';

        var background = {
            backgroundColor: '#ff8a00'
        }

        return (
	        <div className={s.root}>
	            <Helmet title={title} meta={[{"name": "description", "content": "Réflexion, Amélioration, Exécution"}]}/>
                <div className={`spinner ${appear}`} style={background}></div>
	            <div id="serviceConseil" className={`serviceConseil`}>
                    <div className={`bgExpertise`}>
                        <div className={`container`}>
                            <div className={`content`}>
                                <h1 className={`titrePage`}>{titreBanniere}</h1>
                            </div>
                        </div>
                    </div>
                    <main role="main">
                        {topLink}
                        {topContent}
                        <div className={`sectionSchema`}>
                            <div className={`wrapSchema`}>
                                <div className={`container`}>
                                    <div className={`centerCol`}>
                                        <div className={`imageSchema`}>
                                            <span className={`reflexion`}>Réflexion</span>
                                            <div className={`bottomTriangle`}>
                                                <span className={`amelioration`}>Amélioration</span>
                                                <span className={`execution`}>Exécution</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={`sectionPourquoi`}>
                            <span className={`smallTitle`}>Pourquoi choisir</span>
                            <h1 className={`titrePage`}>Prolifik ?</h1>
                            <div className={`circleLine`}>
                                <div className={`circle`}></div>
                                <div className={`line`}></div>
                                <div className={`circle`}></div>
                                <div className={`line`}></div>
                                <div className={`circle`}></div>
                                <div className={`line`}></div>
                                <div className={`circle`}></div>
                            </div>
                            <div className={`pourquoiListe`}>
                                <div className={`container`}>
                                    {sectionPourquoi}
                                </div>
                            </div>
                        </div>
                        <div className={`sectionServices`}>
                            <div className={`container`}>
                                <span className={`smallTitle`}>Nos</span>
                                <h1 className={`titrePage`}>Services</h1>
                                <div className={`wrapServices`}>
                                    {sectionServices}
                                </div>
                            </div> 
                        </div>
                        <div className={`container`}>
                            <div className={`bottomContact`}>
                                <div className={`w50`}>
                                    <span className={`smallTitle`}>Vous désirez</span>
                                    <h1 className={`titrePage`}>Faire des ventes</h1>
                                    <span className={`smallTitle`}>grâce au web</span>
                                </div>
                                <div className={`w50`}>
                                    <div className={`btnSite`}>
                                        <Link to="/contact">Contactez-nous dès maintenant!</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
	    );
    }
}





// WEBPACK FOOTER //
// ./containers/serviceConseil/serviceConseil.js